import { handleApiResponse } from '@src/api/apiClient/axiosClient.ts';
import { companyAuthStatusApiClient } from '@src/api/company/auth/companyAuthStatusApiClient.ts';
import { companyLogoutApiClient } from '@src/api/company/auth/companyLogoutApiClient.ts';
import { fetchCompanyUserProfile } from '@src/context/auth/ProfileFetcher';
import { useCompanyAuth } from '@src/context/auth/useCompanyAuth';
import { COMPANY_URL } from '@src/routes/company';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function CompanyLogout() {
  const navigate = useNavigate();
  const companyAuth = useCompanyAuth();

  useEffect(() => {
    const checkLoginStatus = async () => {
      const res = await companyAuthStatusApiClient.status();
      handleApiResponse(res, (data) => {
        if (!data.is_login) {
          throw new Error('User is not logged in');
        }
      });
    };

    checkLoginStatus()
      .then(async () => {
        await companyLogoutApiClient.logout();
        await fetchCompanyUserProfile(companyAuth.setProfile);
      })
      .catch((error) => console.error('Logout error:', error))
      .finally(() => navigate(COMPANY_URL.HOME));
  }, []);

  return '';
}

export default CompanyLogout;
